/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrimaryMaterial } from '../../models/primary-material';

export interface GetCardViewGroupByMaterial$Params {
  workCenterId: number;
}

export function getCardViewGroupByMaterial(http: HttpClient, rootUrl: string, params: GetCardViewGroupByMaterial$Params, context?: HttpContext): Observable<StrictHttpResponse<PrimaryMaterial>> {
  const rb = new RequestBuilder(rootUrl, getCardViewGroupByMaterial.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PrimaryMaterial>;
    })
  );
}

getCardViewGroupByMaterial.PATH = '/api/v1/PrimaryMaterial/{workCenterId}/CardView/GroupByMaterial';
